import React , {useEffect} from "react";
import { GetProfileImages } from "../DocumentDetails/slice";
import * as ReactDOM from "react-dom";
import {
  Grid,
  GridColumn as Column,
  GridNoRecords,
} from "@progress/kendo-react-grid";
import "@progress/kendo-theme-material/dist/all.css";
import { toODataString } from "@progress/kendo-data-query";
import { useDispatch, useSelector } from "react-redux";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import {
  areaOfActivity,
  ComponentType,
  EntityType,
  EntityTypeQuestion,
  RegistrationPortugeseStatus,
  RegistrationStatus,
} from "../../common/enum";
import i18next, { t } from "i18next";
import { useTranslation } from "react-i18next";
import {
  getEntitiesList,
  setAdminGridCountySelect,
  setAdminGridDistrictSelect,
  setAdminViewEntityDetail,
  setDrawerState,
  setEntitiesLimit,
  setEntitiesOffset,
  setSnackbarMessage,
  setSnackbarOpen,
  setSnackbarSeverity,
  setRejectPayload,
  setConfirmationDialog,
  setHeaderTitle,
} from "../AdminView/adminSlice";
import { DropdownFilterCell } from "./ColumnMenu";
import { debounce, lowerCase } from "lodash";
import Tooltip from "@mui/material/Tooltip";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import InfoIcon from "@mui/icons-material/Info";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {
  Stack,
  Button,
  Typography,
  Box,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Avatar,
  useTheme,
} from "@mui/material";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { updateRegistrationDetail } from "../OnBoarding/slice";
import { AddressData } from "../../common/enum/addressData";
import ConfirmDialog from "../../components/ConfirmDialog";
import { useSnackbar } from "notistack";
import Loader from "../../components/Loader";
import { green } from "@mui/material/colors";
import DocumentDetails from "../DocumentDetails";
import { getDocuments } from "../DocumentDetails/slice";
import Branches from "../AdminView/Branches";
import ProfileCell from "./ProfileCell";
import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
import esMessages from '../Donations/DonationCard/tlklang.json';

loadMessages(esMessages, 'pt-PT');

var INATIVACAO = false;
const LoadingPanel = () => {
  const loadingPanel = (
    <div className="k-loading-mask">
      <span className="k-loading-text">Loading</span>
      <div className="k-loading-image" />
      <div className="k-loading-color" />
    </div>
  );
  const gridContent = document && document.querySelector(".k-grid-content");
  return gridContent
    ? ReactDOM.createPortal(loadingPanel, gridContent)
    : loadingPanel;
};

const AreaOfActivityCell = (props) => {
  const { translate } = useSelector((state) => state);

  const { t } = useTranslation();

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  const areaActivity =
    Object.keys(areaOfActivity)[
      Object.values(areaOfActivity).indexOf(
        props.dataItem.entity.areaOfActivity
      )
    ];
  return (
    <td
      style={props.style}
      className={props.className}
      colSpan={props.colSpan}
      role={"gridcell"}
      aria-selected={props.isSelected}
      aria-colindex={props.ariaColumnIndex}
    >
      {t(`${areaActivity}`)}
    </td>
  );
};

const GroupEntityCell = (props) => {
  const { translate } = useSelector((state) => state);

  const { t } = useTranslation();

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  return (
    <td>
      {props.dataItem.entity.isGroupEntity
        ? t("group")
        : t("singleEstablisment")}
    </td>
  );
};

const StatusCell = (props) => {
  const { translate } = useSelector((state) => state);

  const { t } = useTranslation();

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  return <td>{t(`${props.dataItem.status}`) == 'inativo' ? 'Inativo' : t(`${props.dataItem.status}`)}</td>;
};

const CompanyCell = (props) => {
  const { translate } = useSelector((state) => state);

  const { t } = useTranslation();

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  let companyType =
    props.dataItem.entity.parentEntityId === null ? "Individual" : "child";

  return (
    <td>
      {t(
        `${
          props.dataItem.entity.isParentEntity === true ? "Parent" : companyType
        }`
      )}
    </td>
  );
};

const DistrictCell = (props) => {
  const address = props.dataItem.addresses.filter(
    (item) => item.isHeadquarter === true
  );
  return (
    <td>
      {address.length > 0
        ? address[0].district
        : props.dataItem.addresses[0]?.district}
    </td>
  );
};

const CountyCell = (props) => {
  const address = props.dataItem.addresses.filter(
    (item) => item.isHeadquarter === true
  );
  return (
    <td>
      {address.length > 0
        ? address[0].county
        : props.dataItem.addresses[0]?.county}
    </td>
  );
};

const SubDivisionCell = (props) => {
  const address = props.dataItem.addresses.filter(
    (item) => item.isHeadquarter === true
  );
  return (
    <td>
      {address.length > 0
        ? address[0].subDivision
        : props.dataItem.addresses[0]?.subDivision}
    </td>
  );
};

const TelephoneCell = (props) => {
  const address = props.dataItem.addresses.filter(
    (item) => item.isHeadquarter === true
  );
  return (
    <td>
      {address.length > 0
        ? address[0].phone
        : props.dataItem.addresses[0]?.phone}
    </td>
  );
};

const ViewEntityDetails = ({ t }) => {
  const theme = useTheme();
  const {
    adminDashboard: { adminViewEntityDetail, entitiesLimit, entitiesOffset },
    auth: {
      profile: { entity },
    },
  } = useSelector((state) => state);
  const { enqueueSnackbar } = useSnackbar();

  const dispatch = useDispatch();

  const COVER_URL = "/static/illustrations/illustration_default_banner.jpg";
  const AVATAR_URL = "/static/illustrations/illustration_defaultavatar.png";

  function toLocalISOString(inputDate) {
    const date = inputDate instanceof Date ? inputDate : new Date(inputDate);
  
    if (isNaN(date)) {
      throw new Error('Invalid date');
    }
  
    const offsetMs = date.getTimezoneOffset() * 60000;
    const adjustedDate = new Date(date.getTime() - offsetMs);
    return adjustedDate.toISOString().slice(0, -1);
  }

  const entityType =
    Object.keys(EntityType)[
      Object.values(EntityType).indexOf(adminViewEntityDetail.entity.entityType)
    ];
  const areaActivity =
    Object.keys(areaOfActivity)[
      Object.values(areaOfActivity).indexOf(
        adminViewEntityDetail.entity.areaOfActivity
      )
    ];

  const entityTypeQuestion = adminViewEntityDetail.entity.isGroupEntity
    ? EntityTypeQuestion.groupUnitManangement
    : EntityTypeQuestion.store;

  React.useEffect(() => {
    const data = {
      entityId: adminViewEntityDetail.entity.entityId,
      limit: 10,
      offset: 0,
    };
    dispatch(getDocuments(data));
  }, []);

  const onApprove = React.useCallback(() => {
    const payload = {
      userId: adminViewEntityDetail.entity.entityId,
      status: RegistrationStatus.active,
      registrationApprovedRejectedOn: toLocalISOString(new Date()),
      registrationApprovedRejectedBy: entity.entityId,
    };
    dispatch(updateRegistrationDetail(payload))
      .unwrap()
      .then((res) => {
        let data = {
          limit: entitiesLimit,
          offset: entitiesOffset,
          isParentEntity: `${true}`,
          isApprovedEntities: true,
        };
        dispatch(getEntitiesList(data));
        dispatch(setDrawerState(false));
        enqueueSnackbar({
          message:
            adminViewEntityDetail.status === RegistrationStatus.inActive
              ? t("successfullyActivated")
              : t("successfullyApproved"),
          variant: "success",
        });
      })
      .catch((error) => {
        enqueueSnackbar({
          message: t("somethingWentWrong"),
          variant: "error",
        });
      });
  }, []);

  const onRejectedHandle = React.useCallback(() => {
    const payload = {
      userId: adminViewEntityDetail.entity.entityId,
      status:
        adminViewEntityDetail.status === RegistrationStatus.active
          ? RegistrationStatus.inActive
          : RegistrationStatus.rejected,
      registrationApprovedRejectedOn: toLocalISOString(new Date()),
      registrationApprovedRejectedBy: entity.entityId,
    };
    dispatch(
      setHeaderTitle(
        adminViewEntityDetail.status === RegistrationStatus.active
          ? t("confirmationDeactivateContent")
          : t("confirmationRejectContent")
      )
    );
    {adminViewEntityDetail.status === RegistrationStatus.active  ? INATIVACAO = true : INATIVACAO = false}
    dispatch(setRejectPayload(payload));
    dispatch(setConfirmationDialog(true));
  }, []);
 

  const [entitybanneruri, setentitybanneruri] = React.useState("");
  const [profilepictureuri, setprofilepictureuri] = React.useState("");

  useEffect(() => {
  if(adminViewEntityDetail.entity.bannerImage != "string" && adminViewEntityDetail.entity.bannerImage != null ){
       dispatch(GetProfileImages(adminViewEntityDetail.entity.bannerImage))
       .unwrap()
        .then((response) => {
           if(response.isActive != null){
            setentitybanneruri(response.isActive);
          }else{
            setentitybanneruri(COVER_URL);
          }
        })
    }

    if(adminViewEntityDetail.entity.profilePicture != "string" && adminViewEntityDetail.entity.profilePicture != null ){
       dispatch(GetProfileImages(adminViewEntityDetail.entity.profilePicture))
       .unwrap()
        .then((response) => {
            if(response.isActive != null){
            setprofilepictureuri(response.isActive);
          }else{
            setprofilepictureuri(AVATAR_URL);
          }
        })
    }
	})


  return (
    
    <>
    {/* { console.log(RegistrationStatus.active , "---> aqui")}
    {console.log(adminViewEntityDetail.status, "--> aaa")} */}
      <Box
        sx={{
          height: "110px",
          backgroundImage: `url(${
            adminViewEntityDetail.entity.bannerImage === "string" ||
            adminViewEntityDetail.entity.bannerImage === null
              ? COVER_URL
              : entitybanneruri
          }),url(${COVER_URL})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          position: "relative",
          marginBottom: "40px",
        }}
      >
        <Box
          sx={{
            // position: "absolute",
            width: "100%",
            height: "110px",
            bgcolor: "rgba(0, 0, 0, 0.54)",
            // display: "flex",
            // justifyContent: "flex-start",
          }}
        >
          <Avatar
            alt="Profile picture"
            src={
              adminViewEntityDetail.entity.profilePicture === "string" ||
              adminViewEntityDetail.entity.profilePicture === null
                ? AVATAR_URL
                : profilepictureuri
            }
            sx={{
              position: "absolute",
              backgroundColor: "green",
              margin: "0 30px",
              left: "0",
              right: "0",
              bottom: "0",
              borderRadius: "50%",
              width: "100px",
              height: "100px",
              transform: "translateY(50%)" /* additional 50% of own height */,
              boxShadow: "0 0 0 10px #fff",
              "& img": {
                height:
                  adminViewEntityDetail.entity.profilePicture === "string" ||
                  adminViewEntityDetail.entity.profilePicture === null
                    ? "100%"
                    : "100%",
                width:
                  adminViewEntityDetail.entity.profilePicture === "string" ||
                  adminViewEntityDetail.entity.profilePicture === null
                    ? "100%"
                    : "100%",
              },
            }}
          />
          <Typography
            variant="h6"
            sx={{
              position: "absolute",
              color: "white",
              left: "150px",
              right: "0",
              bottom: "20px",
              fontSize: "1.50rem!important",
              [theme.breakpoints.down("md")]: {
                fontSize: "1.2rem!important",
              },
            }}
          >
            {adminViewEntityDetail.entity.entityName}
          </Typography>
        </Box>
      </Box>
      {(adminViewEntityDetail.status === RegistrationStatus.inActive || adminViewEntityDetail.status == "inativo" ||
        adminViewEntityDetail.status === RegistrationStatus.rejected) && (
        <Box
          sx={{
            // width: 1,
            // border: `1px solid #EE9500`,
            backgroundColor: `#FFFBD4`,
            display: "flex",
            alignItems: "center",
            borderRadius: 1.5,
            p: 1.5,
            mt: 4,
            mx: 2,
          }}
        >
          <InfoIcon
            sx={{
              backgroundColor: `#EE9500`,
              color: "white",
              width: 32,
              height: 32,
              padding: 0.5,
              borderRadius: "10px",
            }}
          />
          <Typography variant="body2" fontWeight={600} mx={2}>
            {adminViewEntityDetail.status === RegistrationStatus.inActive || adminViewEntityDetail.status == "inativo"
              ? `${t("statusInActiveInfo")}`
              : `${t("statusRejectorInfo")}`}
          </Typography>
        </Box>
      )}
      <Box
        sx={{
          padding: 2,
        }}
      >
        <Accordion className="testeacrd"
          sx={{ border: "none", boxShadow: "none" }}
          defaultExpanded={true}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header2"
          >
            <Typography fontSize="26px" marginBottom="0px" gutterBottom>
              {t("profileDetails")}
            </Typography>
          </AccordionSummary>
          <AccordionDetails >
            <Paper 
              //variant="outlined"
              sx={{
                display: "flex",
                flexDirection: "column",
                boxShadow: "none"
               
              }}
            >
           
              <Typography variant="subtitle">
                <b>{t("profileQuestion")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {t(`${entityType}`)}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("activityQuestion")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {t(`${areaActivity}`)}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("entityTypeQuestion")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {t(`${entityTypeQuestion}`)}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("NIF/NIC")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.entity.nic}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("name")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.entity.entityName}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("id")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.entity.entityId}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("registrationEmail")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.email}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("status")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.status == 'inativo' ? "Inativo" :  t(`${adminViewEntityDetail.status}`)}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("actionTakenOn")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.registrationApprovedRejectedOn}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("actionTakenBy")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.registrationApprovedRejectedBy}
              </Typography>
            </Paper>
          </AccordionDetails>
        </Accordion>
    
        <Accordion sx={{ border: "none", boxShadow: "none" }} className="testeacrd">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header2"
          >
            <Typography fontSize="26px" marginBottom="0px" gutterBottom>
              {t("primaryAddress")}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
          <Paper 
            //variant="outlined"
            sx={{
            display: "flex",
            flexDirection: "column",
            boxShadow: "none"
            
            }}
          >
            
              <Typography variant="subtitle">
                <b>{t("addressTitle")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.addresses[0].addressTitle}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("houseHold")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.addresses[0].addressLine}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("district")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.addresses[0].district}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("county")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.addresses[0].county}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("parshi")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.addresses[0].subDivision}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("locality")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.addresses[0].locality}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("postcard")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.addresses[0].postalCode}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("addressEmail")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.addresses[0].email}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("phone")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.addresses[0].phone}
              </Typography>
              
            </Paper>
          </AccordionDetails>
        </Accordion>
        
        <Accordion sx={{ border: "none", boxShadow: "none" }} className="testeacrd">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header2"
          >
            <Typography fontSize="26px" gutterBottom marginBottom="0px">
              {t("contactDetail")}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
          <Paper 
            //variant="outlined"
            sx={{
            display: "flex",
            flexDirection: "column",
            boxShadow: "none"
            
            }}
          >
              <Typography variant="subtitle">
                <b>{t("contactName")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.contact[0].name}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("email")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.contact[0].email}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("designation")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.contact[0].designation}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("mobile")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.contact[0].mobile}
              </Typography>
            </Paper>
          </AccordionDetails>
        </Accordion>
        <Divider />
        <Accordion sx={{ border: "none", boxShadow: "none" }} className="testeacrd">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header2"
          >
            <Typography fontSize="26px" gutterBottom marginBottom="0px">
              {t("document")}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {/* <Paper
              variant="outlined"
              sx={{
                display: "flex",
                flexDirection: "column",
                p: 1,
                mt: 1,
              }}
            >
              <Typography variant="subtitle">
                <b>{t("businessRegistration")}</b>
              </Typography>
              <Typography
                variant="subtitle"
                gutterBottom
                component="a"
                href={
                  adminViewEntityDetail.businessRegistration !== null
                    ? adminViewEntityDetail.businessRegistration
                    : "#"
                }
                target="_blank"
              >
                {adminViewEntityDetail.businessRegistration !== null &&
                  adminViewEntityDetail.businessRegistration.slice(68)}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("mandatedStatement")}</b>
              </Typography>
              <Typography
                variant="subtitle"
                gutterBottom
                component="a"
                href={
                  adminViewEntityDetail.mandatedStatement !== null
                    ? adminViewEntityDetail.mandatedStatement
                    : "#"
                }
                target="_blank"
              >
                {adminViewEntityDetail.mandatedStatement != null &&
                  adminViewEntityDetail.mandatedStatement.slice(68)}
              </Typography>
            </Paper> */}
             <Paper 
              //variant="outlined"
              sx={{
              display: "flex",
              flexDirection: "column",
              boxShadow: "none"
              
              }}
            ></Paper>
            <DocumentDetails
              componentType={ComponentType.ADMIN_VIEW}
              entityId={adminViewEntityDetail.entity.entityId}
              t={t}
            />
          </AccordionDetails>
        </Accordion>
        <Divider />
        <Accordion sx={{ border: "none", boxShadow: "none" }} className="testeacrd"> 
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header2"
          >
            <Typography fontSize="26px" gutterBottom marginBottom="0px">
              {t("otherDetails")}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
          <Paper 
            //variant="outlined"
            sx={{
            display: "flex",
            flexDirection: "column",
            boxShadow: "none"
            
            }}
          >
              <Typography variant="subtitle">
                <b>{t("totalDonations")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.totalNumberOfDonations}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("totalCollections")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.totalNumberOfCollections}
              </Typography>
              <Typography
                variant="subtitle"
                hidden={!adminViewEntityDetail.entity.isGroupEntity}
              >
                <b>{t("noOfChild")}</b>
              </Typography>
              <Typography
                variant="subtitle"
                gutterBottom
                hidden={!adminViewEntityDetail.entity.isGroupEntity}
              >
                {adminViewEntityDetail.totalNumberOfChilds}
              </Typography>
            </Paper>
          </AccordionDetails>
        </Accordion>
        <Divider />
        <Accordion sx={{ border: "none", boxShadow: "none" }} className="testeacrd">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header2"
          >
            <Typography fontSize="26px" gutterBottom marginBottom="0px">
              {t("manageBranches")}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Branches entityId={adminViewEntityDetail.entity.entityId} t={t} />
            <Paper 
              //variant="outlined"
              sx={{
              display: "flex",
              flexDirection: "column",
              boxShadow: "none"
              
              }}
            ></Paper>
          </AccordionDetails>
        </Accordion>
        <Divider />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          {adminViewEntityDetail.status != "ACTIVE" && (
            
            <Button
              variant="contained"
              onClick={onApprove}
              
              sx={{ mr: 1, borderRadius: "4px" , marginTop:"8px"}}
            >
              {adminViewEntityDetail.status === "ACTIVE"
                ?t("approved")
                :t("activate")}
            </Button>
          )}
          {adminViewEntityDetail.status == "ACTIVE" && (
            <Button
              variant="contained"
              onClick={onRejectedHandle}
              id="rejectButton"
              sx={{
                background: "#FFEEEE",
                color: "#FF0000",
                padding: "8px 22px",
                borderRadius: "4px",
                marginTop:"8px",
                "&:hover": { background: "#FF0000", color: "#FFEEEE" },
              }}
            >
              {adminViewEntityDetail.status === 'IN_ACTIVE '
                ? t("rejected")
                : t("deactivate")}
                
            </Button>
          )}
        </Box>
      </Box>
    </>
  );
};

const ActionCell = (props) => {
  const dispatch = useDispatch();

  const {
    auth: { profile: entity },
  } = useSelector((state) => state);
  const { enqueueSnackbar } = useSnackbar();

  const onViewClick = () => {
    dispatch(setDrawerState(true));
    dispatch(setAdminViewEntityDetail(props.dataItem));
  };

  const onApproved = React.useCallback(() => {
    const payload = {
      userId: props.dataItem.entity.entityId,
      status: RegistrationStatus.active,
      registrationApprovedRejectedOn: toLocalISOString(new Date()),
      registrationApprovedRejectedBy: entity.entityId,
    };
    dispatch(updateRegistrationDetail(payload))
      .unwrap()
      .then((res) => {
        enqueueSnackbar({
          variant: "success",
          message: t("successfullyApproved"),
        });
      })
      .catch((error) => {
        enqueueSnackbar({
          variant: "error",
          message: t("somethingWentWrong"),
        });
      });
  }, []);

  const onRejectedHandle = React.useCallback(() => {
    const payload = {
      userId: props.dataItem.entity.entityId,
      status:
        props.dataItem.status === RegistrationStatus.active
          ? RegistrationStatus.inActive
          : RegistrationStatus.rejected,
      registrationApprovedRejectedOn: toLocalISOString(new Date()),
      registrationApprovedRejectedBy: entity.entityId,
    };
    dispatch(
      setHeaderTitle(
        props.dataItem.status === RegistrationStatus.active
          ? t("confirmationDeactivateContent")
          : t("confirmationRejectContent")
      )
    );
    dispatch(setRejectPayload(payload));
    dispatch(setConfirmationDialog(true));
  }, []);

  return (
    <td
      style={props.style} // this applies styles that lock the column at a specific position
      className={props.className} // this adds classes needed for locked columns
      colSpan={props.colSpan}
      role={"gridcell"}
      aria-colindex={props.ariaColumnIndex}
      aria-selected={props.isSelected}
    >
      <Stack direction={"row"} mt="10px" alignItems="center" spacing={1}>
        <Tooltip title={t("viewDetails")} arrow>
          <Button sx={{ p: 0, minWidth: 0 }} onClick={onViewClick}>
            <RemoveRedEyeIcon fontSize="small" />
          </Button>
        </Tooltip>
        {/* {props.dataItem.status !== RegistrationStatus.active && (
          <Tooltip title={t("approved")} arrow>
            <Button sx={{ p: 0, minWidth: 0,padding:2}} onClick={onApproved}>
              <DoneIcon fontSize="small" />
            </Button>
          </Tooltip>
        )}
        {(props.dataItem.status !== RegistrationStatus.rejected ||
          props.dataItem.status !== RegistrationStatus.revoked ||
          props.dataItem.status !== RegistrationStatus.inActive) && (
          <Tooltip
            title={
              props.dataItem.status === RegistrationStatus.active
                ? t("deactivate")
                : t("rejected")
            }
            arrow
          >
            <Button sx={{ p: 0, minWidth: 0,padding :props.dataItem.status === RegistrationStatus.active ? 1.5:0 }} onClick={onRejectedHandle}>
              <ClearIcon fontSize="small" />
            </Button>
          </Tooltip>
        )} */}
      </Stack>
    </td>
  );
};

const StatusFilterCell = (props) => {
  return (
    <DropdownFilterCell
      {...props}
      data={Object.values(RegistrationPortugeseStatus)}
      defaultItem={"Selecione um Estado"}
    />
  );
};

const DistrictFilterCell = (props) => {
  return (
    <DropdownFilterCell
      {...props}
      data={AddressData.map((item) => item.district)}
      defaultItem={"Selecione um Distrito"}
    />
  );
};

const CountyFilterCell = (props) => {
  const {
    adminDashboard: { adminGridDistrictSelect },
  } = useSelector((state) => state);

  const countyNames = React.useMemo(() => {
    if (adminGridDistrictSelect !== "") {
      return AddressData.find(
        (item) => item.district === adminGridDistrictSelect
      ).county.map((item) => item.countyName);
    }
    return [];
  }, [adminGridDistrictSelect]);

  return (
    <DropdownFilterCell
      {...props}
      data={countyNames}
      defaultItem={"Selecione um Concelho"}
    />
  );
};

const FerguesiaFilterCell = (props) => {
  const {
    adminDashboard: { adminGridDistrictSelect, adminGridCountySelect },
  } = useSelector((state) => state);

  const freguesiaNames = React.useMemo(() => {
    if (adminGridDistrictSelect !== "" && adminGridCountySelect !== "") {
      return AddressData.find(
        (item) => item.district === adminGridDistrictSelect
      )
        .county.find((item) => item.countyName === adminGridCountySelect)
        .fregusias.map((item) => item.freguesiaName);
    }
    return [];
  }, [adminGridDistrictSelect, adminGridCountySelect]);

  return (
    <DropdownFilterCell
      {...props}
      data={freguesiaNames}
      defaultItem={"Selecione uma Freguesia"}
    />
  );
};

const Datagrid = ({ t }) => {
  const {
    adminDashboard: {
      entitiesList,
      entitiesCount,
      drawerState,
      rejectPayload,
      entitiesLimit,
      entitiesOffset,
      confirmationDialog,
      loading,
      headerTitle,
    },
  } = useSelector((state) => state);
  const theme = useTheme();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const handleClose = React.useCallback(() => {
    dispatch(setConfirmationDialog(false));
  }, [dispatch]);

  const onConfirm = () => {
    dispatch(updateRegistrationDetail(rejectPayload))
      .unwrap()
      .then((res) => {
        let data = {
          limit: entitiesLimit,
          offset: entitiesOffset,
          isParentEntity: `${true}`,
          isApprovedEntities: true,
        };
        dispatch(getEntitiesList(data));
        dispatch(setConfirmationDialog(false));
        dispatch(setDrawerState(false));
        enqueueSnackbar({
          variant: "success",
          message:
            rejectPayload.status === RegistrationStatus.inActive
              ? t("successfullyDeactivated")
              : t("successfullyRejected"),
        });
      })
      .catch((error) => {
        enqueueSnackbar({
          variant: "error",
          message: t("somethingWentWrong"),
        });
      });
  };

  const filterOperators = {
    text: [
      {
        text: "grid.filterContainsOperator",
        operator: "contains",
      },
    ],
    numeric: [
      {
        text: "grid.filterEqOperator",
        operator: "eq",
      },
    ],
    date: [
      {
        text: "grid.filterEqOperator",
        operator: "eq",
      },
    ],
    boolean: [
      {
        text: "grid.filterEqOperator",
        operator: "eq",
      },
    ],
  };

  const timer = React.useRef(null);
  const [dataState, setDataState] = React.useState({
    take: 20,
    skip: 0,
  });

  React.useEffect(() => {
    const data = {
      limit: dataState.take + dataState.skip,
      offset: dataState.skip,
      isParentEntity: `${true}`,
      isApprovedEntities: true,
    };
    dispatch(getEntitiesList(data));
  }, []);

  const debouncedApiCall = debounce(async (value) => {
    const limit = value.skip + value.take;
    const offset = value.skip;
    let data = {
      limit: limit,
      offset: offset,
      isParentEntity: `${true}`,
      isApprovedEntities: true,
    };
    if (value.filter !== undefined) {
      value?.filter.filters.map((item) => {
        switch (item.field) {
          case "district":
            data["district"] = item.value;
            dispatch(setAdminGridDistrictSelect(item.value));
            break;
          case "county":
            data["county"] = item.value;
            dispatch(setAdminGridCountySelect(item.value));
            break;
          case "subDivision":
            data["subDivison"] = item.value;
            break;
          case "entity.entityName":
            data["entityName"] = item.value;
            break;
          case "status":
            data["status"] = Object.keys(RegistrationPortugeseStatus).find(
              (key) => RegistrationPortugeseStatus[key] === item.value
            );
            break;
        }
      });
    } else {
      dispatch(setAdminGridDistrictSelect(""));
      dispatch(setAdminGridCountySelect(""));
    }
    dispatch(getEntitiesList(data));
    dispatch(setEntitiesLimit(limit));
    dispatch(setEntitiesOffset(offset));
  }, 1000);

  const dataStateChange = (e) => {
    const value = e.dataState;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      debouncedApiCall(value);
    }, 1000);
    setDataState(e.dataState);
  };

  return (
    <React.Fragment>
      {loading && <Loader phrase={"adminEntitiesLoadingPhrase"} t={t} />}
      {!loading && (
        <>
        <LocalizationProvider language="pt-PT" >
          <IntlProvider locale="pt">
          <Grid
          data={entitiesList}
          style={{ height: "70vh" }}
          resizable={true}
          // skip={page.skip}
          // take={page.take}
          filterOperators={filterOperators}
          total={entitiesCount}
          pageable={true}
          {...dataState}
          // onPageChange={pageChange}
          onDataStateChange={dataStateChange}
          filterable={true}
          // groupable={true}
        >
          <GridNoRecords>{t("noRecordAvailable")}</GridNoRecords>
          {/* <Column
            field="entity.entityId"
            title={t("id")}
            filterable={false}
            width={"100px"}
          /> */}
          <Column
            field="entity.entityName"
            title={t("name")}
            filter={"text"}
            width={"280px"}
            minResizableWidth={200}
            locked={true}
          />
          <Column
            field="entity.entityType"
            title={t("profile")}
            filterable={false}
            cell={ProfileCell}
            width={"250px"}
          />
          <Column
            field="entity.areaOfActivity"
            title={`${t("activity")}`}
            cell={AreaOfActivityCell}
            filterable={false}
            width={"110px"}
          />
          <Column
            field="entity.isGroupEntity"
            title={`${t("groupEntity")}`}
            cell={GroupEntityCell}
            filterable={false}
            width={"150px"}
          />
          <Column
            field="district"
            title={t("district")}
            filterCell={DistrictFilterCell}
            cell={DistrictCell}
            width={"300px"}
          />
          <Column
            field="county"
            title={t("county")}
            filterCell={CountyFilterCell}
            cell={CountyCell}
            width={"350px"}
          />
          <Column
            field="subDivision"
            title={t("parshi")}
            filterCell={FerguesiaFilterCell}
            cell={SubDivisionCell}
            width={"350px"}
          />
          <Column
            field="telefone"
            title={`${t("phone")}`}
            cell={TelephoneCell}
            filterable={false}
            width={"150px"}
          />
           <Column
            field="totalNumberOfDonations"
            title={t("totalDonations")}
            filterable={false}
            width={"150px"}
          />
          <Column
            field="totalNumberOfCollections"
            title={t("totalCollections")}
            filterable={false}
            width={"150px"}
          />
          {/* <Column
            field="entity.isParentEntity"
            title={t("companyType")}
            filterable={false}
            cell={CompanyCell}
            width={"160px"}
          /> */}
          <Column
            field="totalNumberOfChilds"
            title={t("noOfChild")}
            filterable={false}
            width={"160px"}
          />
          <Column
            field="status"
            title={t("status")}
            filterCell={StatusFilterCell}
            cell={StatusCell}
            width={"300px"}
          />
          <Column
            field=""
            title={`Ações`}
            cell={ActionCell}
            filterable={false}
            width={"100px"}
            minResizableWidth={100}
            locked={true}
          />
        </Grid>
          </IntlProvider>
          </LocalizationProvider>
        </>
        
      )}
      {/* <EntitiesLoader dataState={dataState} /> */}
      <Drawer
        anchor={"right"}
        open={drawerState}
        PaperProps={{
          sx: {
            width: "50%",
            [theme.breakpoints.down("md")]: {
              width: 1,
            },
          },
        }}
        onClose={() => {
          dispatch(setDrawerState(false));
        }}
      >
        <Button
          sx={{
            position: "fixed",
            right: "51%",
            top: 10,
            zIndex: 1,
            minWidth: 0,
            borderRadius: "4px",
            padding: "4px",
            backgroundColor: "#ffc3c3",
            "&:hover": {
              backgroundColor: "#ffc3c3",
            },
            "@media (max-width:900px)": {
              right: "1%",
            },
          }}
          onClick={() => {
            dispatch(setDrawerState(false));
          }}
        >
          <CloseOutlinedIcon color="error" />
        </Button>
        <ViewEntityDetails t={t} />
      </Drawer>
      <ConfirmDialog
        open={confirmationDialog}
        handleClose={handleClose}
        title={t("")}
        inativacao = {INATIVACAO}
        content={headerTitle}
        onConfirm={onConfirm}
        cancelButtonTitle={t("cancel")}
        confirmButtonTitle={t("confirm")}
      />
    </React.Fragment>
  );
};

export default Datagrid;
